import type { EvidenceItemListModel, EvidenceItemModel } from "./evidence";

export type LegalAidCategory = "advokatvagt" | "retshjaelp";

export interface LegalAidEvidenceModel extends EvidenceItemModel {
  category: LegalAidCategory;
  extractedNumberOfLessons?: number;
}

export interface LegalAidEvidenceListModel extends EvidenceItemListModel {
  category: LegalAidCategory;
}

export const formatLegalAidCategory = (category: LegalAidCategory): string =>
  category === "advokatvagt" ? "Advokatvagt" : "Retshjælp";
